import { useState } from 'react'
import { LocalizationObject } from '../redux/slices/userSlice'

export const useLocalization = (initialValues: LocalizationObject): any => {
    const [localization, setLocalization] =
        useState<LocalizationObject>(initialValues)
    const [isLocalizationUpdated, setIsLocalizationUpdated] =
        useState<boolean>(false)

    const handleLocalizationChange = (
        key: keyof LocalizationObject,
        value: string,
    ) => {
        setLocalization((prev) => {
            return {
                ...prev,
                [key]: value,
            }
        })
        setIsLocalizationUpdated(true)
    }

    return {
        localization,
        setLocalization,
        handleLocalizationChange,
        isLocalizationUpdated,
    }
}
